export default __webpack_public_path__ + "static/media/Mutual of Omaha.f95bb98f.svg";